import { ReactElement } from 'react';

function PostNotFound(): ReactElement<HTMLDivElement> {
  return (
    <div className="flex flex-col items-center">
      <svg
        className="h-12 w-12"
        width="512"
        height="512"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M384 80H128C102 80 85 94 80 120L48 272V384C48.0369 396.719 53.1059 408.907 62.0997 417.9C71.0934 426.894 83.281 431.963 96 432H416C428.719 431.963 440.907 426.894 449.9 417.9C458.894 408.907 463.963 396.719 464 384V272L432 120C427 93 409 80 384 80Z"
          stroke="#D1D9D9"
          strokeWidth="32"
          strokeLinejoin="round"
        />
        <path
          d="M192 272C192 288.974 198.743 305.252 210.745 317.255C222.747 329.257 239.026 336 256 336C272.974 336 289.252 329.257 301.255 317.255C313.257 305.252 320 288.974 320 272M48 272H192H48ZM320 272H464H320Z"
          stroke="#D1D9D9"
          strokeWidth="32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className="text-sm text-gray-500 font-body">No post yet.</p>
    </div>
  );
}

export default PostNotFound;
